import * as swcHelpers from '@swc/helpers';
import { isString } from '@grandvisionhq/utils';
import { getUrl } from '../../utils/get-url.js';

const parselinkConfigurator = (linkConfigurator, page)=>{
    var _label, ref, ref1;
    return {
        label: (_label = linkConfigurator === null || linkConfigurator === void 0 ? void 0 : linkConfigurator.linkSelector.label) !== null && _label !== void 0 ? _label : '',
        url: (ref = getUrl(linkConfigurator === null || linkConfigurator === void 0 ? void 0 : linkConfigurator.linkSelector.url, page)) !== null && ref !== void 0 ? ref : '',
        icon: (ref1 = linkConfigurator === null || linkConfigurator === void 0 ? void 0 : linkConfigurator.icon) !== null && ref1 !== void 0 ? ref1 : ''
    };
};
// This is the key that BR uses to set the hidden property on a container component
const PARAMETER_HIDDEN = 'com.onehippo.cms7.targeting.TargetingParameterUtil.hide';
// Default properties on bloomreach content and meta objects
// that are always there, but we don't require on component level
const omitKeysContent = [
    'displayName',
    'versionedNode',
    '_links',
    'localeString',
    'type'
];
const omitKeysMeta = [
    PARAMETER_HIDDEN,
    'document',
    'mobile',
    'tablet',
    'desktop'
];
function parseBloomreachContent(content = {}) {
    return Object.keys(content).reduce((result, key)=>omitKeysContent.includes(key) ? result : swcHelpers.objectSpread({}, result, {
            [key]: content[key]
        })
    , {});
}
function parseBloomreachMeta(meta) {
    return Object.keys(meta).reduce((result, key)=>omitKeysMeta.includes(key) ? result : swcHelpers.objectSpread({}, result, {
            [key]: meta[key]
        })
    , {});
}
const getCommonParams = ({ title , theme , template  })=>swcHelpers.objectSpread({}, isString(title) ? {
        title
    } : {}, isString(theme) ? {
        theme
    } : {}, isString(template) ? {
        template
    } : {})
;
function fetchPagedComponent(url, componentId) {
    return _fetchPagedComponent.apply(this, arguments);
}
function _fetchPagedComponent() {
    _fetchPagedComponent = swcHelpers.asyncToGenerator(function*(url, componentId, pageIndex = 1, path = '/blog') {
        const response = yield fetch(`${url}/resourceapi${path}?_hn%3Atype=component-rendering&_hn%3Aref=${componentId}&page=${pageIndex}`, {
            method: 'GET',
            headers: {
                'Accept-Version': '1.0'
            }
        });
        return response.json();
    });
    return _fetchPagedComponent.apply(this, arguments);
}

export { fetchPagedComponent, getCommonParams, parseBloomreachContent, parseBloomreachMeta, parselinkConfigurator };
//# sourceMappingURL=helpers.js.map
